var _style, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0F0F0;}\n\t.st1{fill:#338AF3;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 256
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,189.2h247.2c-6.4-23.8-16.2-46.3-28.8-66.8H256V189.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M96.6,456.3h318.7c23.4-18.6,43.4-41.2,59.1-66.8H37.6C53.2,415.1,73.3,437.7,96.6,456.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89,61.9c-20.1,17.3-37.5,37.7-51.5,60.5H89V61.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,256c0-26.1,0-47.9,0-66.8H155.8V256H89v-66.8H8.8C3.1,210.5,0,232.9,0,256s3.1,45.5,8.8,66.8h494.4 c5.7-21.3,8.8-43.7,8.8-66.8H256z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,0c-35.5,0-69.4,7.3-100.2,20.3v102.1H256c0-23.3,0-43.1,0-66.8h159.4C371.6,20.8,316.2,0,256,0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGr);
export default __webpack_public_path__ + "static/media/gr.53ef17e2e21a8e796233445568820955.svg";
export { ForwardRef as ReactComponent };